import React from 'react';
import DocumentMeta from 'react-document-meta';
import Container from 'react-bootstrap/Container';
import Navigation from '../composants/commun/navigation';
import { useState } from 'react';
import PiedPage from '../composants/commun/pied-page';
import TitrePage from '../composants/commun/titre-page';
import ListeTarifs from '../composants/tarifs/liste-tarifs';
import { obtenirMeta } from '../utilitaires/utilMeta';

export default function PageTarifs() {
    const meta = obtenirMeta(window.location)
    const [state]  = useState({
      meta: meta
    });
    return (
        <DocumentMeta {...state.meta}>
        <Container fluid>
          <Navigation></Navigation>
          <TitrePage titre="Tarifs"></TitrePage>
          <ListeTarifs></ListeTarifs>
          <PiedPage></PiedPage>
        </Container>
      </DocumentMeta>
    );
  }